<ng-container *ngIf="!input.isList">
    <div class="input-container" [ngClass]="{'input-row':input.isRow}">
        <label [for]="input.id" *ngIf="input.label">
            {{input.label}}
            <span class="mandatory" *ngIf="input.required">*</span>
        </label>
        <div class="options" [style]="input.style">
            <ng-container [ngSwitch]="input.type">
                <input *ngSwitchCase="parameterType.string" class="form-input" [id]="input.id" type="text"
                    [ngClass]="{'error':hasErrors()}" [style]="input.style" [formControl]="control">
                <input *ngSwitchCase="parameterType.number" class="form-input" placeholder="Escribe solo números"
                    [id]="input.id" type="text" [allowNegativeNumbers]="true" mask="separator.5" thousandSeparator=""
                    [ngClass]="{'error':hasErrors()}" [style]="input.style" [formControl]="control">
                <input *ngSwitchCase="parameterType.date" class="form-input" [id]="input.id" placeholder="yyyy-mm-dd"
                    ngbDatepicker #date="ngbDatepicker" (click)="date.toggle()" [ngClass]="{'error':hasErrors()}"
                    [style]="input.style" [formControl]="control">
            </ng-container>
            <button type="button" class="btn-add" (click)="formatValue()">Agregar</button>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="input.isList">
    <div class="input-container">
        <label [for]="input.id" *ngIf="input.label">
            {{input.label}}
            <span class="mandatory" *ngIf="input.required">*</span>
        </label>
        <div class="multi-select" [style]="input.style">
            <button class="btn-multi" type="button" data-bs-toggle="dropdown" aria-expanded="false"
                [ngClass]="{'error':hasErrors()}">
                Seleccione
                <fa-icon class="arrow-icon" [icon]="faAngleDown"></fa-icon>
            </button>
            <ul class="dropdown-menu multi-options">
                <li *ngFor="let option of input.options" (click)="addValue(option)">
                    <ng-container [ngTemplateOutlet]="input.type===parameterType.date ?dateValue : defaultValue"
                        [ngTemplateOutletContext]="{value:option}">
                    </ng-container>
                </li>
            </ul>
        </div>
    </div>
</ng-container>
<div class="multiple-values">
    <span *ngFor="let item of formArray.controls , let j = index" (click)="removeParameterValue(j)">
        <ng-container [ngTemplateOutlet]="input.type===parameterType.date ?dateValue : defaultValue"
            [ngTemplateOutletContext]="{value:item.value}">
        </ng-container>
        <fa-icon class="arrow-icon" [icon]="faCircleXmark"></fa-icon>
    </span>
</div>

<ng-template #defaultValue let-value='value'>
    {{ value }}
</ng-template>

<ng-template #dateValue let-value='value'>
    {{value | date: "YYYY-MM-dd" }}
</ng-template>